import React, { useEffect, useState } from 'react';

import { connect } from 'react-redux';
import ErrorBoundary from 'containers/ErrorBoundary';
import Growl from 'containers/Growl';

import { Creators as AuthCreators, isUserAuth } from 'store/ducks/auth';

import ModalVerificationEmail from 'components/ModalVerificationEmail';
import { LoadingSpinner, FreshChat } from 'triider-components';

import GlobalStyles from './styles/global';
import Interceptor from './axiosInterceptor';

const App = ({
  location,
  loadingVisible,
  _getUserByHash,
  children,
  tokenUser,
  triiderUser,
  user,
  isOpenModalEmail,
}) => {
  const [localLoader, setLocalLoader] = useState(true);
  const setUp = async () => {
    const { search, pathname, query } = location;
    let companyUrl = pathname.split('partner/')[1];
    if (companyUrl === undefined) {
      companyUrl = pathname.split('inquilino/')[1] || pathname.split('parceiro/')[1];
    }
    const companyName = companyUrl ? companyUrl.split('/')[0] : '';
    const parsedCompany = companyName && companyName.toLowerCase();
    // se companyName estiver vazio a empresa default é triider
    if (parsedCompany.includes('vila') || parsedCompany.includes('luiz')) {
      window.location = process.env.NOT_FOUND;
      return;
    }

    if (search) {
      // receive token
      const tokenSearch = query.token;

      const payload = { companyName, token: tokenSearch };
      await _getUserByHash(payload);
    } else {
      const payload = { companyName };
      await _getUserByHash(payload);
    }

    setLocalLoader(false);
  };

  useEffect(() => {
    setUp();
  }, []);

  if (loadingVisible || localLoader) {
    return <LoadingSpinner loadingVisible />;
  }

  return (
    <>
      <Growl />
      <ErrorBoundary>
        <ModalVerificationEmail
          open={!loadingVisible && isOpenModalEmail}
          emailUser={user && (user.email || user.possible_email)}
          documentUser={user && (user.cpf || user.cnpj)}
        />
        <GlobalStyles />
        <FreshChat triiderUser={triiderUser} tags={['empresas']} />
        <Interceptor />
        {children}
      </ErrorBoundary>
    </>
  );
};

const mapStateToProps = state => ({
  tokenUser: state.auth.triiderUser && state.auth.triiderUser.token,
  user: state.auth.triiderUser && state.auth.triiderUser.user,
  isOpenModalEmail: state.auth && state.auth.isOpenModalEmail,
  location: state.router.location,
  loadingVisible: state.ui.loaders.includes('GETUSER'),
  triiderUser: state.auth.triiderUser && state.auth.triiderUser,
});

const mapDispatchToProps = {
  _getUserByHash: AuthCreators.getUserByHashRequest,
  _loginSuccess: AuthCreators.loginSuccess,
  _login: AuthCreators.loginRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
